import { render, staticRenderFns } from "./CargaArchivo.vue?vue&type=template&id=3952898b&lang=true"
import script from "./CargaArchivo.vue?vue&type=script&lang=js"
export * from "./CargaArchivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports